var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M272 64H128v384h256V175.5zm0 22.6 89.8 89.4H272zM144 432V80h112v112h112v240z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }